import React, { useEffect, useRef, useState } from 'react';

const Testimonials = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  // Auto-rotate testimonials
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 6000);
    return () => clearInterval(timer);
  }, []);

  const testimonials = [
    {
      name: 'Safwan',
      position: 'CEO',
      company: 'Delta Trading Hub',
      avatar: '/api/placeholder/80/80',
      rating: 5,
      testimonial: "The customer portal provided for our Forex trading operations is exceptional. It’s a secure, high-performance solution that has significantly streamlined our client interactions. Their technical expertise and dedicated support made the entire integration seamless and highly efficient.",
      project: 'Customer portal of forex Trade',
      industry: 'Financial Services',
      companyLogo: '/api/placeholder/120/40'
    },
    {
      name: 'Al Jaleel',
      position: 'Director',
      company: 'Infolinks',
      avatar: '/api/placeholder/80/80',
      rating: 5,
      testimonial: "The CRM delivered by the team has transformed our workflow. Its seamless integration and user-centric design have significantly enhanced our operational efficiency and data accuracy. We highly recommend their professional approach and high-performance digital solutions for any growing business.",
      project: 'CRM',
      industry: 'Technology',
      companyLogo: '/api/placeholder/120/40'
    },
    {
      name: 'Thoyib',
      position: 'Managing Director',
      company: 'Blue Magic Dry Clean',
      avatar: '/api/placeholder/80/80',
      rating: 5,
      testimonial: "The laundry mobile app has revolutionized our customer experience. Its intuitive design and seamless ordering process have significantly increased our efficiency. We highly value the professional support and high-performance digital solution that has helped our business grow and modernise.",
      project: 'Customer mobile App for Laundry',
      industry: 'Services',
      companyLogo: '/api/placeholder/120/40'
    },
    {
      name: 'Ranjith',
      position: 'CFO',
      company: 'PNI Logistics',
      avatar: '/api/placeholder/80/80',
      rating: 5,
      testimonial: "PNI Logistics has seen a significant boost in operational efficiency thanks to this high-performance management software. Its seamless tracking and intuitive design have transformed our logistics workflow. We highly value the technical expertise and dedicated support provided throughout the entire integration.",
      project: 'Logistics management software',
      industry: 'Logistics',
      companyLogo: '/api/placeholder/120/40'
    }
  ];

  const clientLogos = [
    { name: 'Global Bank Corp', logo: '/api/placeholder/140/60' },
    { name: 'MedCare Solutions', logo: '/api/placeholder/140/60' },
    { name: 'ShopGlobal Inc', logo: '/api/placeholder/140/60' },
    { name: 'City of Innovation', logo: '/api/placeholder/140/60' },
    { name: 'GlobalManufacturing', logo: '/api/placeholder/140/60' },
    { name: 'EduFuture Academy', logo: '/api/placeholder/140/60' },
    { name: 'TechStartup Pro', logo: '/api/placeholder/140/60' },
    { name: 'Enterprise Solutions', logo: '/api/placeholder/140/60' }
  ];

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <svg
        key={index}
        className={`w-5 h-5 ${index < rating ? 'text-yellow-400' : 'text-gray-300'}`}
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
      </svg>
    ));
  };

  return (
    <section id="testimonials" ref={sectionRef} className="section-padding bg-slate-50">
      <div className="container-custom">
        {/* Section Header */}
        <div className={`text-center mb-16 ${isVisible ? 'animate-fadeInUp' : 'opacity-0'}`}>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-slate-900 mb-6">
            Client <span className="gradient-text">Testimonials</span>
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-cyan-400 mx-auto mb-8"></div>
          <p className="text-lg md:text-xl text-slate-600 max-w-4xl mx-auto leading-relaxed text-left">
            Our clients trust us to deliver high-performance digital solutions that drive real business growth. Through precision, security, and dedicated support,
            we transform complex challenges into scalable, user-centric software success.
          </p>
        </div>

        {/* Main Testimonial Slider */}
        <div className={`mb-20 ${isVisible ? 'animate-fadeInUp' : 'opacity-0'}`} style={{ animationDelay: '0.2s' }}>
          <div className="relative">
            {/* Current Testimonial */}
            <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12 max-w-4xl mx-auto">
              <div className="grid lg:grid-cols-3 gap-8 items-center">
                {/* Client Info */}
                <div className="text-center lg:text-left">
                  {/* <div className="w-20 h-20 mx-auto lg:mx-0 mb-4">
                    <img
                      src={testimonials[currentTestimonial].avatar}
                      alt={testimonials[currentTestimonial].name}
                      className="w-full h-full rounded-full object-cover"
                    />
                  </div> */}
                  <h4 className="font-bold text-xl text-slate-900 mb-1">
                    {testimonials[currentTestimonial].name}
                  </h4>
                  <p className="text-slate-600 mb-2">
                    {testimonials[currentTestimonial].position}
                  </p>
                  <p className="text-blue-600 font-semibold mb-4">
                    {testimonials[currentTestimonial].company}
                  </p>

                  <div className="flex justify-center lg:justify-start mb-4">
                    {renderStars(testimonials[currentTestimonial].rating)}
                  </div>

                  <div className="bg-slate-100 rounded-lg px-4 py-2 inline-block">
                    <span className="text-xs font-medium text-slate-700">
                      {testimonials[currentTestimonial].industry}
                    </span>
                  </div>
                </div>

                {/* Testimonial Content */}
                <div className="lg:col-span-2">
                  <div className="relative">
                    <svg className="absolute -top-4 -left-4 w-12 h-12 text-blue-100" fill="currentColor" viewBox="0 0 32 32">
                      <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" />
                    </svg>
                    <blockquote className="text-lg md:text-xl text-slate-700 leading-relaxed mb-6 relative z-10">
                      {testimonials[currentTestimonial].testimonial}
                    </blockquote>
                  </div>

                  <div className="flex items-center justify-between">
                    <div>
                      <p className="font-semibold text-slate-900">Project:</p>
                      <p className="text-blue-600">{testimonials[currentTestimonial].project}</p>
                    </div>
                    {/* <div className="h-8">
                      <img
                        src={testimonials[currentTestimonial].companyLogo}
                        alt={testimonials[currentTestimonial].company}
                        className="h-full object-contain opacity-60"
                      />
                    </div> */}
                  </div>
                </div>
              </div>
            </div>

            {/* Navigation Dots */}
            <div className="flex justify-center mt-8 space-x-2">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentTestimonial(index)}
                  className={`w-3 h-3 rounded-full transition-all duration-300 ${index === currentTestimonial
                      ? 'bg-blue-600 w-8'
                      : 'bg-gray-300 hover:bg-gray-400'
                    }`}
                />
              ))}
            </div>

            {/* Navigation Arrows */}
            <button
              onClick={() => setCurrentTestimonial(prev => prev === 0 ? testimonials.length - 1 : prev - 1)}
              className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white shadow-lg rounded-full p-3 hover:bg-slate-50 transition-all duration-200"
            >
              <svg className="w-6 h-6 text-slate-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
            </button>
            <button
              onClick={() => setCurrentTestimonial(prev => (prev + 1) % testimonials.length)}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white shadow-lg rounded-full p-3 hover:bg-slate-50 transition-all duration-200"
            >
              <svg className="w-6 h-6 text-slate-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>
        </div>

        {/* Client Logos */}
        {/* <div className={`${isVisible ? 'animate-fadeInUp' : 'opacity-0'}`} style={{ animationDelay: '0.4s' }}>
          <div className="text-center mb-12">
            <h3 className="font-display text-2xl md:text-3xl font-semibold text-slate-900 mb-4">
              Trusted by Industry Leaders
            </h3>
            <p className="text-slate-600 max-w-2xl mx-auto">
              Join 200+ companies that trust Ascali with their digital transformation
            </p>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-4 gap-8 items-center">
            {clientLogos.map((client, index) => (
              <div
                key={index}
                className="flex items-center justify-center p-6 bg-white rounded-xl shadow-sm hover:shadow-md transition-all duration-300 group"
              >
                <img
                  src={client.logo}
                  alt={client.name}
                  className="max-h-8 w-auto object-contain opacity-60 group-hover:opacity-100 transition-opacity duration-300"
                />
              </div>
            ))}
          </div>
        </div> */}

        {/* Statistics */}
        <div className={`mt-20 ${isVisible ? 'animate-fadeInUp' : 'opacity-0'}`} style={{ animationDelay: '0.6s' }}>
          <div className="bg-gradient-to-br from-slate-900 to-slate-800 rounded-3xl p-8 md:p-12">
            <div className="text-center mb-12">
              <h3 className="font-display text-3xl md:text-4xl font-semibold text-white mb-4">
                Numbers That Matter
              </h3>
              <p className="text-gray-300 max-w-2xl mx-auto">
                Our commitment to excellence is reflected in the results we deliver
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center text-white">
              {[
                { number: '98%', label: 'Client Satisfaction Rate', icon: '😊' },
                { number: '500+', label: 'Successful Projects', icon: '🚀' },
                { number: '24/7', label: 'Technical Support', icon: '🔧' },
                { number: '50+', label: 'Industries Served', icon: '🌍' }
              ].map((stat, index) => (
                <div key={index} className="group">
                  <div className="text-4xl mb-4">{stat.icon}</div>
                  <div className="text-3xl md:text-4xl font-bold font-display mb-2 gradient-text">
                    {stat.number}
                  </div>
                  <div className="text-gray-300 group-hover:text-white transition-colors duration-300">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;